var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    {
      attrs: {
        "align-center": "",
        "justify-center": "",
        column: "",
        tabindex: "0",
      },
      on: { keydown: _vm.handleKeyDown },
    },
    [
      _c(
        "v-card",
        {
          staticStyle: { "background-color": "var(--v-light-primary-base)" },
          attrs: { flat: "" },
        },
        [
          _c(
            "v-card-text",
            [
              _vm.isOnCall
                ? _c("v-text-field", {
                    staticClass: "centered-input text-h6 font-weight-semibold",
                    attrs: {
                      value: _vm.phoneNumber,
                      clearable: "",
                      flat: "",
                      solo: "",
                      "background-color": "light-primary",
                      "hide-details": "auto",
                    },
                    on: {
                      "click:clear": function ($event) {
                        _vm.phoneNumber = ""
                      },
                    },
                  })
                : _c(
                    "v-col",
                    { staticClass: "px-0 pb-0" },
                    [
                      _c("combobox-phone", {
                        ref: "phone",
                        attrs: {
                          "background-color": "light-primary",
                          placeholder: _vm.$t("add-phone"),
                          label: _vm.$t("phone"),
                          "default-country": _vm.defaultCountry,
                          "is-dialpad": true,
                        },
                        on: {
                          validate: _vm.onValidate,
                          "update-search": _vm.setPhoneNumber,
                        },
                        model: {
                          value: _vm.phoneNumber,
                          callback: function ($$v) {
                            _vm.phoneNumber = $$v
                          },
                          expression: "phoneNumber",
                        },
                      }),
                    ],
                    1
                  ),
              _c(
                "div",
                [
                  _vm._l(_vm.buttons, function (row, rowIndex) {
                    return _c(
                      "v-layout",
                      {
                        key: rowIndex,
                        attrs: {
                          "no-gutters": "",
                          "align-center": "",
                          "justify-center": "",
                        },
                      },
                      _vm._l(row, function (button, buttonIndex) {
                        return _c(
                          "v-btn",
                          {
                            key: buttonIndex,
                            staticClass: "ma-1",
                            attrs: { color: "primary", fab: "", outlined: "" },
                            on: {
                              click: function ($event) {
                                return _vm.addDigit(button)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "text-h5 font-weight-bold" },
                              [_vm._v(" " + _vm._s(button) + " ")]
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  }),
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        "no-gutters": "",
                        "align-center": "",
                        "justify-center": "",
                      },
                    },
                    [
                      !_vm.isOnCall
                        ? [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  color: "primary",
                                  fab: "",
                                  depressed: "",
                                  disabled: !_vm.isValid,
                                },
                                on: { click: _vm.outboundCall },
                              },
                              [
                                _c("v-icon", { attrs: { large: "" } }, [
                                  _vm._v("mdi-phone-in-talk"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  !_vm.isOnCall && _vm.extensions.length
                    ? [
                        _c("v-divider", { staticClass: "my-2" }),
                        _c(
                          "div",
                          { staticClass: "text-caption text--secondary mb-1" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("transfer-extensions")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          _vm._l(_vm.extensions, function (extension) {
                            return _c(
                              "v-col",
                              { key: extension.id, attrs: { cols: "6" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "extension-btn text-none justify-start",
                                    attrs: {
                                      block: "",
                                      outlined: "",
                                      color: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.extensionCall(extension)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", small: "" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              extension.type === "partner"
                                                ? "mdi-domain"
                                                : "mdi-phone-classic"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "text-truncate" },
                                      [_vm._v(_vm._s(extension.name))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }